module.exports = __webpack_public_path__ + "img/process_img04.3f08fb68.png";